import { render, staticRenderFns } from "./purorderbatchchange.vue?vue&type=template&id=075399cf&scoped=true&"
import script from "./purorderbatchchange.vue?vue&type=script&lang=js&"
export * from "./purorderbatchchange.vue?vue&type=script&lang=js&"
import style0 from "./purorderbatchchange.vue?vue&type=style&index=0&id=075399cf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075399cf",
  null
  
)

export default component.exports